export class Alert {

    public message = '';
    public type = 'warning';
    public autoHide = true;
    public autoHideTime = 5000;

    constructor(message: string) {
        this.message = message;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/alert/Alert.ts